module.exports = __webpack_public_path__ + "static/ofcar8-a75ebc637a9a88b005e08c4938b230ad.jpg";